module.exports = __webpack_public_path__ + "img/3.3a9598c0.png";